import { CommsCohort } from '@/features/comms/screens/CommsCohort';

/**
 * Standalone "Chat V2 Cohort" ops page (comms canary).
 *
 * Lets ops see and manage which workers are on the Supabase comms backend.
 * Talks only to the graphy admin REST API (`/api/admin/comms/allowlist`), so
 * unlike the Chat V2 page it needs no Supabase client / provider.
 *
 * Ops-gated (TENANT_ADMIN / HELPDESK_ADMIN) at the route layer, mirroring the
 * Chat V2 route.
 */
const ChatV2Cohort = () => <CommsCohort />;

export default ChatV2Cohort;
